import React from 'react';
import { Link } from 'react-router-dom';
import Col from '../../Col';
import ServiceRequestFormDialog from '../ServiceRequestFormDialog';
import Row from '../../Row';
import Button from '../../Button';
import { variables } from 'src/Tenants';
import {
  useServiceRequestFormReviewOrchestrator,
  UseServiceRequestFormReviewOrchestratorReturn,
} from './useServiceRequestFormReviewOrchestrator';
import './ServiceRequestFormReview.scss';

const OVIEDO_STRAPLINE =
  'Thank you for submitting a service request. We respond to all inquiries in the order they are received and will do our best to resolve any concerns you may have.';

const SHAPE_STRAPLINE = OVIEDO_STRAPLINE;

const ServiceRequestFormReview = () => {
  const {
    confirmationHeader,
    confirmationBody,
    theme,
    ticketNumber,
    issueType,
    assetName,
    make,
    model,
    suiteAndProperty,
    buildingName,
    unitAddress,
    isStaffReviewer,
    serviceRequestViewPath,
    onViewServiceRequest,
    onViewServiceRequestLink,
    onExit,
  }: UseServiceRequestFormReviewOrchestratorReturn =
    useServiceRequestFormReviewOrchestrator();

  const renderStrapline = () => {
    if (theme === 'Oviedo') {
      return (
        <div className="sr-form-review__strapline">
          {OVIEDO_STRAPLINE}
          <br />
          Please allow up to 7 business days for a reply. <br />
          <br />
          For any emergencies or urgent matters, please follow the instructions
          noted in your homeowner manuals.
        </div>
      );
    }

    if (theme === 'Shape') {
      return (
        <div className="sr-form-review__strapline">
          {SHAPE_STRAPLINE}
          <br />
          Please allow up to 30 business days for a reply. <br />
          <br />
          For any emergencies or urgent matters, please follow the instructions
          noted in your homeowner manuals.
        </div>
      );
    }

    return <div className="sr-form-review__strapline">{confirmationBody}</div>;
  };

  const renderFooter = () => {
    if (isStaffReviewer) {
      return (
        <Button
          color="teal"
          label={`View ${variables.serviceRequest}`}
          size="small"
          onClick={onViewServiceRequest}
        />
      );
    }

    return (
      <Button
        color="teal"
        size="small"
        label={
          <Link
            className="sr-form-review-view-link"
            to={serviceRequestViewPath}
            onClick={onViewServiceRequestLink}
          >
            View {variables.serviceRequest}
          </Link>
        }
      />
    );
  };

  return (
    <ServiceRequestFormDialog
      title=""
      onExit={onExit}
      confirmOnExit={false}
      footer={renderFooter()}
    >
      <Row mdCenter>
        <Col xs="12" md="6">
          <div className="sr-form-review__image">
            <img
              src="/assets/service-request-review.svg"
              alt="Review service request"
            />
          </div>
          <div className="sr-form-review__headline">{confirmationHeader}</div>
          {renderStrapline()}
          <div className="sr-form-review__heading">
            Your {variables.serviceRequest} ticket number is
            <div className="sr-form-review__number">{ticketNumber}</div>
          </div>
          <table className="sr-form-review__table">
            <tbody>
              <tr>
                <td className="sr-form-review__label">Issue Type / Asset</td>
                <td className="sr-form-review__value">
                  {issueType} / {assetName}
                </td>
              </tr>
              <tr>
                <td className="sr-form-review__label">Make / Model</td>
                <td className="sr-form-review__value">
                  {make} / {model}
                </td>
              </tr>
              <tr>
                <td className="sr-form-review__label">
                  {variables.Suite} / Property
                </td>
                <td className="sr-form-review__value">{suiteAndProperty}</td>
              </tr>
              {buildingName ? (
                <tr>
                  <td className="sr-form-review__label">Building</td>
                  <td className="sr-form-review__value">{buildingName}</td>
                </tr>
              ) : null}
              {unitAddress ? (
                <tr>
                  <td className="sr-form-review__label">Address</td>
                  <td className="sr-form-review__value">{unitAddress}</td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </Col>
      </Row>
    </ServiceRequestFormDialog>
  );
};

export default ServiceRequestFormReview;